import {
	Col,
	Container,
	Form,
	FormGroup,
	OverlayTrigger,
	Row,
	Spinner,
	Tooltip,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
	ContentBody,
	ContentHeader,
	DropdownFilter,
	PrimaryButton,
} from "../../styled";
import { DetailsForm } from "../components/details-form";
import { MenuForm } from "../components/menu-form";
import { PickListForm } from "../components/picklist-form";
import { BibliographyForm } from "../components/bibliography-form";
import { useState } from "react";
import { ObjectCategoryForm } from "../components/object-category-form";
import { FileUploadForm } from "../components/file-upload-form";
import { Dropdown } from "primereact/dropdown";

import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Error from "../../../../components/Error";
import {
	createMaterial,
	setItemsToDisciplinaManager,
} from "../../../../services/discipline.service";
import { toast } from "react-toastify";
import { ItemPickListForm } from "../components/item-picklist-form";
import { setMediasToItemManager } from "../../../../services/item.service";
import {
	completeMediaUpload,
	s3UploadFile,
	unzipMedia,
	uploadMediaFile,
} from "../../../../services/media.service";
import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { Modal } from "../../../../components/modal";

export const CreateProduct = (): JSX.Element => {
	const history = useHistory();
	const { t: translation } = useTranslation();

	const [loading, setLoading] = useState(false);
	const [loadingModal, setLoadingModal] = useState(false);
	const [showFreeModal, setShowFreeModal] = useState(false);

	const [productType, setProductType] = useState<any>();
	const [addedMediaFile, setAddedMediaFile] = useState(false);
	const [mediaFileAdd, setMediaFileAdd] = useState<any>();
	const [executablePath, setExecutablePath] = useState<string>();

	const productTypeItems = [
		{ name: translation("manager.type.discipline"), value: "Discipline" },
		{ name: translation("manager.type.unity"), value: "Item" },
		{ name: translation("manager.type.theme"), value: "Theme" },
		{ name: translation("manager.type.object"), value: "Object" },
	];

	const validationSchema = Yup.object({
		title: Yup.string().trim().required("Este campo é obrigatório"),
		description: Yup.string(),
		type: Yup.string().trim().required("Este campo é obrigatório"),
		code: Yup.string().trim().required("Este campo é obrigatório"),
		workload:
			productType && productType === "Discipline"
				? Yup.string().required("Este campo é obrigatório")
				: Yup.string(),
		category: Yup.number(),
		reference: Yup.string(),
		discipline: Yup.number(),
		discipline_items: Yup.array(),
		item_medias: Yup.array(),
		delivery_values: Yup.array(),
		knowledge_area: Yup.array()
			.min(1, "Este campo é obrigatório")
			.required("Este campo é obrigatório"),
		item: Yup.string(),
		price: Yup.number().nullable(),
		is_base_price: Yup.boolean(),
	});

	const {
		register,
		handleSubmit,
		control,
		setValue,
		reset,
		formState: { errors },
	} = useForm({ resolver: yupResolver(validationSchema) });

	const onSubmit = (formData: any) => {
		if (formData.price === 0) {
			setShowFreeModal(true);
		} else {
			handleSubmitFreeMaterial(formData);
		}
	};

	const handleSubmitFreeMaterial = (formData?: any) => {
		setLoading(true);
		setLoadingModal(true);

		let itemList: any = {};
		createMaterial(productType, formData)
			.then((data) => {
				if (productType === "Discipline") {
					itemList = handleChainItems(data.id, productType, formData);
					if (itemList.length > 0) {
						setItemsToDisciplinaManager(itemList).then((_data) => {
							handleSuccesMessage();
						});
					} else {
						handleSuccesMessage();
					}
				} else if (productType === "Item" || productType === "Theme") {
					itemList = handleChainItems(data.id, productType, formData);
					if (itemList.length > 0) {
						setMediasToItemManager(itemList).then((_data) => {
							handleSuccesMessage();
						});
					} else {
						handleSuccesMessage();
					}
				} else if (
					(productType === "Media" || productType === "Object") &&
					addedMediaFile
				) {
					let form = {
						name: mediaFileAdd.name,
						format: mediaFileAdd?.type,
						preview_file_index: executablePath,
					};

					uploadMediaFile(data.id, form)
						.then((_res) => {
							s3UploadFile(
								_res.tmp_url,
								mediaFileAdd,
								_res.format
							).then(() => {
								completeMediaUpload(data.id).then(() => {
									if (executablePath) {
										unzipMedia(data.id).then(() => {
											handleSuccesMessage();
											setAddedMediaFile(false);
											setMediaFileAdd(null);
										});
									} else {
										handleSuccesMessage();
										setAddedMediaFile(false);
										setMediaFileAdd(null);
									}
								});
							});
						})
						.catch((err) => {
							toast.error("Ocorreu um erro ao criar o material.");
							setLoading(false);
							setLoadingModal(false);
						});
				} else {
					handleSuccesMessage();
					setShowFreeModal(false);
				}
			})
			.catch((err) => {
				toast.error("Ocorreu um erro ao criar o material.");
				setLoading(false);
				setLoadingModal(false);
			});
	};

	const handleSuccesMessage = () => {
		toast.success("Material adicionado com sucesso!");
		setLoading(false);
		setProductType("");
		reset();
		history.push("/manager/materials-manager");
	};

	const handleChainItems = (id: any, type: any, formData: any) => {
		let itemList: any = {};
		if (
			type === "Discipline" &&
			formData.discipline_items &&
			formData.discipline_items.length > 0
		) {
			let lista: any[] = [];
			formData.discipline_items.map((item: any) => {
				lista.push(item.id);
			});

			itemList = {
				discipline: id,
				items: lista,
			};
		} else if (
			(type === "Item" || type === "Theme") &&
			formData.item_medias &&
			formData.item_medias.length > 0
		) {
			let lista: any[] = [];
			formData.item_medias.map((item: any) => {
				lista.push(item.id);
			});

			itemList = {
				item: id,
				medias: lista,
			};
		}
		return itemList;
	};

	return (
		<Container fluid>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<ContentHeader>
					<Row>
						<Col className="mb-2">
							<span className="title">
								<OverlayTrigger
									placement="top"
									overlay={
										<Tooltip>{translation("back")}</Tooltip>
									}
								>
									<span>
										<HiOutlineArrowCircleLeft
											className="mr-1 mb-1 cursor-pointer"
											onClick={() => history.goBack()}
										/>
									</span>
								</OverlayTrigger>
								Adicionar material
							</span>
						</Col>
						<Col md={2} xxl={1} className="text-end">
							{loading ? (
								<Spinner
									animation="border"
									variant="primary"
									style={{
										width: "2rem",
										height: "2rem",
										borderWidth: "0.25em",
										borderRightColor: "transparent",
									}}
								/>
							) : (
								<PrimaryButton
									style={{ width: "100%", float: "right" }}
								>
									<button name="addbutton" type="submit">
										{translation("manager.button.add")}
									</button>
								</PrimaryButton>
							)}
						</Col>
					</Row>
				</ContentHeader>
				<ContentBody>
					<Row className="mt-3">
						<Col className="mb-3">
							<FormGroup>
								<Form.Label>
									{translation("manager.labels.title")}
								</Form.Label>
								<Form.Control
									id="title"
									type="text"
									placeholder={translation(
										"manager.labels.title"
									)}
									{...register("title", { required: true })}
								></Form.Control>
								{errors.title ? (
									<div className="w-100">
										{" "}
										<Error>
											{errors.title?.message}
										</Error>{" "}
									</div>
								) : (
									""
								)}
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Form.Label>
									{translation("manager.labels.materialType")}
								</Form.Label>
								<DropdownFilter>
									<Dropdown
										optionLabel="name"
										value={productType}
										options={productTypeItems}
										onChange={(e) => {
											setProductType(e.value);
											setValue("type", e.value);
										}}
										placeholder={translation(
											"manager.selects.materialType"
										)}
									/>
									{errors.type ? (
										<div className="w-100">
											{" "}
											<Error>
												{errors.type?.message}
											</Error>{" "}
										</div>
									) : (
										""
									)}
								</DropdownFilter>
							</FormGroup>
						</Col>
					</Row>

					{productType ? (
						<>
							<Row className="mt-3">
								<Col md={12}>
									<DetailsForm
										updateData={true}
										type={productType}
										formRegister={register}
										formErrors={errors}
										handleSetValue={setValue}
										control={control}
									></DetailsForm>
								</Col>
							</Row>

							{productType != "Object" ? (
								<>
									<Row className="mt-3">
										<Col>
											<MenuForm
												updateData={true}
												formRegister={register}
												formErrors={errors}
												handleSetValue={setValue}
												productType={productType}
											></MenuForm>
										</Col>
									</Row>
									<Row className="mt-3">
										<Col xs={12}>
											{productType === "Discipline" ? (
												<>
													<PickListForm
														updateData={true}
														handleSetValue={
															setValue
														}
													></PickListForm>
												</>
											) : (
												<></>
											)}

											{productType === "Item" ||
											productType === "Theme" ? (
												<>
													<ItemPickListForm
														updateData={true}
														handleSetValue={
															setValue
														}
													></ItemPickListForm>
												</>
											) : (
												<></>
											)}
										</Col>
									</Row>
									<Row className="mt-3">
										<Col>
											<BibliographyForm
												updateData={true}
												handleSetValue={setValue}
											></BibliographyForm>
										</Col>
									</Row>
								</>
							) : (
								<>
									<Row className="mt-3">
										<Col>
											<FileUploadForm
												updateData={true}
												onAdd={setMediaFileAdd}
												executablePath={
													setExecutablePath
												}
												isAdded={setAddedMediaFile}
											></FileUploadForm>
										</Col>
										<Col md={4}>
											<ObjectCategoryForm
												updateData={true}
												handleSetValue={setValue}
												control={control}
											></ObjectCategoryForm>
										</Col>
									</Row>
								</>
							)}

							<Row className="mt-3">
								<Col md={{ span: 2, offset: 10 }}>
									{loading ? (
										<Spinner
											animation="border"
											variant="primary"
											style={{
												width: "2rem",
												height: "2rem",
												borderWidth: "0.25em",
												borderRightColor: "transparent",
											}}
										/>
									) : (
										<PrimaryButton
											style={{
												width: "70%",
												float: "right",
												marginBottom: "15px",
											}}
										>
											<button
												name="addbutton"
												type="submit"
												disabled={loading}
											>
												{translation(
													"manager.button.add"
												)}
											</button>
										</PrimaryButton>
									)}
								</Col>
							</Row>
						</>
					) : (
						<></>
					)}
				</ContentBody>
			</Form>

			<Modal
				headerTitle="Aviso"
				submitButtonText={translation("continue")}
				show={showFreeModal}
				onHide={() => setShowFreeModal(false)}
				onSubmit={handleSubmitFreeMaterial}
				variant="confirm-modal-default"
				loading={loadingModal}
			>
				<p className="font-16">
					Você inseriu um valor de <b>R$ 0,00</b>. Este material
					aparecerá como <b>GRATUITO</b> na loja.
				</p>
				<p className="font-14">
					Tem certeza que deseja continuar mesmo assim?
				</p>
			</Modal>
		</Container>
	);
};
